import {
  createContext, useContext, useEffect, useMemo, useState,
} from 'react';
import { useAuth } from './AuthContext';
import { subscribeTerritories } from '../data/listeners/territories';

// The active tenant's territories, made tenant-aware app-wide. Every territory
// picker / label lookup reads from here instead of a hardcoded constant, so a
// new tenant shows ITS OWN territories (drawn in Territory Settings), not Presto's.
const TerritoriesContext = createContext(undefined);

export function TerritoriesProvider({ children }) {
  const { tenantId, role, territoryIds } = useAuth();
  const [territories, setTerritories] = useState([]);

  useEffect(
    () => subscribeTerritories({ tenantId, role, territoryIds }, setTerritories, () => setTerritories([])),
    [tenantId, role, territoryIds],
  );

  const value = useMemo(() => {
    const sorted = [...territories].sort((a, b) =>
      (a.rollout ?? 99) - (b.rollout ?? 99)
      || String(a.label ?? a.id).localeCompare(String(b.label ?? b.id)));
    const labelMap = Object.fromEntries(sorted.map((t) => [t.id, t.label ?? t.id]));
    return { territories: sorted, terrLabel: (id) => labelMap[id] ?? id };
  }, [territories]);

  return <TerritoriesContext.Provider value={value}>{children}</TerritoriesContext.Provider>;
}

export function useTerritories() {
  const ctx = useContext(TerritoriesContext);
  if (ctx === undefined) throw new Error('useTerritories must be used within a TerritoriesProvider.');
  return ctx;
}
